import Layout from './Layout';

export default Layout;


// WEBPACK FOOTER //
// ./src/layout/index.js